export const validation = {
  titleMaxChar: 50,
  paragraphMaxChar: 100,
  title: { required: true },
  socials: {
    min: 0,
    max: 6
  }
}